<template>
  <section>
    <div class="device_info_popup">
      <!-- <pre class="max-h-[300px] overflow-x-scroll">{{ config }}</pre> -->

      <template v-for="_video in config.videos" :key="_video">
        <template v-if="_video.open && _video?.url != undefined">
          <Video :config="config" :video="_video" />
        </template>
      </template>

      <div
        class="absolute z-50 bottom-0 bg-g0-dark/95 w-full opacity-50 hover:opacity-100 transition-opacity duration-200"
        :style="
          config.reduce ? 'top: calc(100% - 30px); overflow: hidden;' : ''
        "
      >
        <Flight_All :config="config" />
        <div class="border-y border-g0 flex">
          <!-- DOCK -->
          <template v-if="config?.dock?.id != undefined">
            <DockAlert :config="config" />
            <div class="flex w-full">
              <DockQuickStatus
                :config="config"
                size="w-[100px] min-w-[100px] max-w-[100px]"
              />

              <div class="flex items-center justify-between w-full">
                <div class="flex flex-col w-full justify-between p-2">
                  <div class="flex items-center justify-between">
                    <div class="mb-2 text-base">
                      <DockStatus :config="config" />
                    </div>
                    <HMS_btn
                      :config="config"
                      :classTpl="{
                        div: 'cursor-pointer aspect-square ml-4 w-[24px]',
                        svg: 'w-full',
                      }"
                    />
                  </div>
                  <div class="flex items-center">
                    <!-- LastDockStatus -->
                    <LastDockStatus :config="config" />
                    <div class="w-[15px]"></div>
                    <!-- Vent / Pluie -->
                    <DockWindRain :config="config" />
                  </div>

                  <div>
                    <Video_List dockList="true" :config="config" />
                  </div>
                </div>

                <!-- DockAction : activeBTN -->
                <div
                  class="h-full cursor-pointe p-[5px] flex items-center justify-center hover:bg-flyingeye-light"
                  :class="{
                    'bg-g2': !config.ActionPopup,
                    'bg-flyingeye': config.ActionPopup,
                  }"
                  @click="config.ActionPopup = !config.ActionPopup"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    viewBox="0 0 15.71 15.709"
                  >
                    <path
                      d="M16.805,0A2.805,2.805,0,1,1,14,2.805,2.806,2.806,0,0,1,16.805,0Zm0,1.122a1.683,1.683,0,1,0,1.683,1.683A1.684,1.684,0,0,0,16.805,1.122Z"
                      transform="translate(-6.145 0)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M16.805,18A2.805,2.805,0,1,1,14,20.805,2.806,2.806,0,0,1,16.805,18Zm0,1.122a1.683,1.683,0,1,0,1.683,1.683A1.684,1.684,0,0,0,16.805,19.122Z"
                      transform="translate(-6.145 -7.901)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M6.805,9A2.805,2.805,0,1,1,4,11.805,2.806,2.806,0,0,1,6.805,9Zm0,1.122a1.683,1.683,0,1,0,1.683,1.683A1.684,1.684,0,0,0,6.805,10.122Z"
                      transform="translate(-1.755 -3.951)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M22.561,5.122a.561.561,0,1,1,0-1.122h2.244a.561.561,0,1,1,0,1.122Z"
                      transform="translate(-9.657 -1.756)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M22.561,23.122a.561.561,0,1,1,0-1.122h2.244a.561.561,0,1,1,0,1.122Z"
                      transform="translate(-9.657 -9.657)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M2.805,13a.561.561,0,0,1,0,1.122H.561A.561.561,0,1,1,.561,13Z"
                      transform="translate(0.001 -5.706)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M.561,5.122A.561.561,0,0,1,.561,4H8.136a.561.561,0,0,1,0,1.122Z"
                      transform="translate(0 -1.756)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M.561,23.122A.561.561,0,1,1,.561,22H8.415a.561.561,0,1,1,0,1.122Z"
                      transform="translate(0.001 -9.657)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M22.171,13a.561.561,0,1,1,0,1.122h-5.61a.561.561,0,1,1,0-1.122Z"
                      transform="translate(-7.023 -5.706)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </template>

          <!-- RC+ -->
          <template v-if="config?.rcPlus?.id != undefined">
            <div class="flex w-full">
              <RcPlusQuickStatus
                :config="config"
                size="w-[120px] min-w-[120px] max-w-[120px]"
              />

              <div class="flex w-full flex-wrap">
                <div class="px-2 flex justify-between items-center py-2 w-full">
                  <!-- RcPlusStatus -->
                  <div class="text-base w-full">
                    <RcPlusStatus :config="config" />
                  </div>
                  <div class="ml-2 flex">
                    <!-- RcPlusLastStatus -->
                    <RcPlusLastStatus :config="config" />
                  </div>
                </div>

                <div class="px-2 py-1 flex items-center justify-between w-full">
                  <!-- RcPlusBatt -->
                  <RcPlusBatt :config="config" />

                  <!-- SDR -->
                  <div class="flex items-center">
                    <RcPlusSdr :config="config">
                      <RcPlusSdrNetQuality :config="config" />
                    </RcPlusSdr>
                  </div>
                </div>
              </div>

              <!-- RcPlusAction : activeBTN -->
              <div
                class="h-auto cursor-pointe p-[5px] flex items-center justify-center hover:bg-flyingeye-light"
                :class="{
                  'bg-g2': !config.ActionPopup,
                  'bg-flyingeye': config.ActionPopup,
                }"
                @click="config.ActionPopup = !config.ActionPopup"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  viewBox="0 0 15.71 15.709"
                >
                  <path
                    d="M16.805,0A2.805,2.805,0,1,1,14,2.805,2.806,2.806,0,0,1,16.805,0Zm0,1.122a1.683,1.683,0,1,0,1.683,1.683A1.684,1.684,0,0,0,16.805,1.122Z"
                    transform="translate(-6.145 0)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M16.805,18A2.805,2.805,0,1,1,14,20.805,2.806,2.806,0,0,1,16.805,18Zm0,1.122a1.683,1.683,0,1,0,1.683,1.683A1.684,1.684,0,0,0,16.805,19.122Z"
                    transform="translate(-6.145 -7.901)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M6.805,9A2.805,2.805,0,1,1,4,11.805,2.806,2.806,0,0,1,6.805,9Zm0,1.122a1.683,1.683,0,1,0,1.683,1.683A1.684,1.684,0,0,0,6.805,10.122Z"
                    transform="translate(-1.755 -3.951)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M22.561,5.122a.561.561,0,1,1,0-1.122h2.244a.561.561,0,1,1,0,1.122Z"
                    transform="translate(-9.657 -1.756)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M22.561,23.122a.561.561,0,1,1,0-1.122h2.244a.561.561,0,1,1,0,1.122Z"
                    transform="translate(-9.657 -9.657)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M2.805,13a.561.561,0,0,1,0,1.122H.561A.561.561,0,1,1,.561,13Z"
                    transform="translate(0.001 -5.706)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M.561,5.122A.561.561,0,0,1,.561,4H8.136a.561.561,0,0,1,0,1.122Z"
                    transform="translate(0 -1.756)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M.561,23.122A.561.561,0,1,1,.561,22H8.415a.561.561,0,1,1,0,1.122Z"
                    transform="translate(0.001 -9.657)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M22.171,13a.561.561,0,1,1,0,1.122h-5.61a.561.561,0,1,1,0-1.122Z"
                    transform="translate(-7.023 -5.706)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
            </div>

            <RcPlusAction :config="config" />
          </template>

          <!-- DRONE -->
          <template v-if="config?.drone?.id != undefined">
            <div class="flex w-full">
              <DroneQuickStatus
                :config="config"
                size="w-[120px] min-w-[120px] max-w-[120px]"
              />

              <div class="flex flex-col p-2 w-full">
                <div class="flex items-center justify-between w-full">
                  <!-- Status -->
                  <div class="mb-2 text-base w-full">
                    <DroneStatus :config="config" />
                  </div>

                  <!-- LastDroneStatus -->
                  <div class="w-full flex justify-end">
                    <LastDroneStatus :config="config" />
                  </div>
                </div>

                <div class="w-full flex items-center text-sm justify-between">
                  <!-- Batt -->
                  <DroneBatt :config="config" />

                  <!-- Storage -->
                  <DroneStorage :config="config" />
                </div>

                <div v-if="DroneAlive">
                  <Video_List :config="config" />
                </div>
              </div>
            </div>
          </template>
        </div>

        <DockAction :config="config" />

        <template v-if="config?.drone?.id != undefined">
          <template v-if="DroneAlive">
            <DroneFlightBatt :config="config" />
            <div>
              <div class="flex justify-between text-sm p-2">
                <DroneRTK :config="config" />
                <DroneHSpeed :config="config" />
                <DroneVSpeed :config="config" />
                <DroneElevation :config="config" />
                <DroneWindSpeed :config="config" />
              </div>
            </div>
          </template>

          <div>
            <Flight_ControlePanel
              v-if="config.flight.openControlPanel"
              @close="
                () => {
                  config.flight.openControlPanel = false;
                }
              "
              :config="config"
            />
          </div>
        </template>

        <Flight_Action :config="config" />
      </div>
    </div>

    <HMS :config="config" />
  </section>
</template>

<script>
import Flight_All from "@/partials/Device/Template/Flight/Flight_All.vue";
import Flight_ControlePanel from "@/partials/Device/Template/Flight/Flight_ControlePanel.vue";
// ---
import Video from "@/partials/Video/Video.vue";
import Video_List from "@/partials/Video/Videos_List.vue";
import HMS from "@/partials/Device/Template/HMS/HMS.vue";
import HMS_btn from "@/partials/Device/Template/HMS/HMS_btn.vue";
import Flight_Action from "@/partials/Device/Template/Flight/Flight_Action.vue";
import Setting from "@/partials/Video/Camera/Setting.vue";
// --- DOCK
import DockAlert from "@/partials/Device/Template/Dock/DockAlert.vue";
import DockStatus from "@/partials/Device/Template/Dock/DockStatus.vue";
import DockQuickStatus from "@/partials/Device/Template/Dock/DockQuickStatus.vue";
import DockAction from "@/partials/Device/Template/Dock/DockAction.vue";
import DockWindRain from "@/partials/Device/Template/Dock/DockWindRain.vue";
import LastDockStatus from "@/partials/Device/Template/Dock/LastDockStatus.vue";
// --- RC+
import RcPlusQuickStatus from "@/partials/Device/Template/Rc+/RcPlusQuickStatus.vue";
import RcPlusStatus from "@/partials/Device/Template/Rc+/RcPlusStatus.vue";
import RcPlusLastStatus from "@/partials/Device/Template/Rc+/RcPlusLastStatus.vue";
import RcPlusMap from "@/partials/Device/Template/Rc+/RcPlusMap.vue";
import RcPlusBatt from "@/partials/Device/Template/Rc+/RcPlusBatt.vue";
import RcPlus4GNetQuality from "@/partials/Device/Template/Rc+/RcPlus4GNetQuality.vue";
import RcPlus4GNetQualityToDrone from "@/partials/Device/Template/Rc+/RcPlus4GNetQualityToDrone.vue";
import RcPlus4G from "@/partials/Device/Template/Rc+/RcPlus4G.vue";
import RcPlusSdrNetQuality from "@/partials/Device/Template/Rc+/RcPlusSdrNetQuality.vue";
import RcPlusSdr from "@/partials/Device/Template/Rc+/RcPlusSdr.vue";
import RcPlusAction from "@/partials/Device/Template/Rc+/RcPlusAction.vue";
// --- DRONE
import DroneQuickStatus from "@/partials/Device/Template/Drone/DroneQuickStatus.vue";
import DroneStatus from "@/partials/Device/Template/Drone/DroneStatus.vue";
import DroneHSpeed from "@/partials/Device/Template/Drone/DroneHSpeed.vue";
import DroneVSpeed from "@/partials/Device/Template/Drone/DroneVSpeed.vue";
import DroneElevation from "@/partials/Device/Template/Drone/DroneElevation.vue";
import LastDroneStatus from "@/partials/Device/Template/Drone/LastDroneStatus.vue";
import DroneRTK from "@/partials/Device/Template/Drone/DroneRTK.vue";
import DroneGPS from "@/partials/Device/Template/Drone/DroneGPS.vue";
import DroneBatt from "@/partials/Device/Template/Drone/DroneBatt.vue";
import DroneWindSpeed from "@/partials/Device/Template/Drone/DroneWindSpeed.vue";
import DroneMap from "@/partials/Device/Template/Drone/DroneMap.vue";
import DroneFlightBatt from "@/partials/Device/Template/Drone/DroneFlightBatt.vue";
import DroneStorage from "@/partials/Device/Template/Drone/DroneStorage.vue";

export default {
  name: "Device_Info_Popup",
  props: {
    config: Object,
  },
  components: {
    Flight_All,
    Flight_ControlePanel,
    // ---
    Flight_Action,
    Video,
    Video_List,
    HMS,
    HMS_btn,
    Setting,
    // --- Dock
    DockAlert,
    DockQuickStatus,
    DockStatus,
    DockWindRain,
    LastDockStatus,
    DockAction,
    // --- RC+
    RcPlusQuickStatus,
    RcPlusStatus,
    RcPlusLastStatus,
    RcPlusMap,
    RcPlusBatt,
    RcPlus4GNetQuality,
    RcPlus4GNetQualityToDrone,
    RcPlus4G,
    RcPlusSdrNetQuality,
    RcPlusSdr,
    RcPlusAction,
    // --- Drone
    DroneQuickStatus,
    DroneStatus,
    DroneHSpeed,
    DroneVSpeed,
    DroneElevation,
    LastDroneStatus,
    DroneRTK,
    DroneGPS,
    DroneBatt,
    DroneWindSpeed,
    DroneMap,
    DroneFlightBatt,
    DroneStorage,
  },
  setup() {
    return {};
  },

  mounted() {},

  methods: {},
  computed: {
    DroneAlive() {
      let LastPing =
        this.config?.drone?.status?.LastPing != null
          ? parseInt(this.config.drone.status.LastPing)
          : ENV.DEVICE_OFFLINE;

      return LastPing < ENV.DEVICE_OFFLINE;
    },
  },
};
</script>
